/**
 * Persistor reference for use in sagas (e.g. flush before redirect).
 * Set by store.js on init to avoid circular imports.
 */
let persistorRef = null;

export const setPersistor = (persistor) => {
  persistorRef = persistor;
};

export const getPersistor = () => persistorRef;
